import styled from 'styled-components';

import { Annotation } from './styled/text';

const ListWrapper = styled.div`
  display: flex;
  flex-direction: column;
`;

const ListHeader = styled.div`
  display: grid;
  grid-template-columns: ${(props) =>
    props.columnsMobile ? props.columnsMobile : '1fr'};
  grid-column-gap: 1rem;
  padding: 0.25rem 1rem;
  @media (min-width: ${(props) => props.theme.medium}) {
    grid-template-columns: ${(props) =>
      props.columns ? props.columns : '4fr 2fr 2fr 2fr 2.5rem'};
  } ;
`;

export const ListHeaderItem = styled(Annotation)`
  color: ${(props) => props.theme.primary};
  font-weight: 600;
`;

const ListItems = styled.ul`
  margin: 0;
  padding: 0;
  list-style-type: none;
  border-top: ${(props) =>
    props.noBorder ? '0' : '1px solid' + props.theme.stroke};
`;

export const ListItem = styled.li`
  list-style: none;
  display: grid;
  grid-template-columns: ${(props) =>
    props.columnsMobile ? props.columnsMobile : '1fr'};
  grid-column-gap: 1rem;
  align-items: center;
  padding: 0.5rem 1rem;
  border-bottom: 1px solid ${(props) => props.theme.stroke};
  background-color: ${(props) => props.theme.noContrast};
  cursor: ${(props) => (props.hasAction ? 'pointer' : 'initial')};
  transition: 0.225s all;
  min-height: 40px;
  &:hover {
    background-color: ${(props) =>
      props.hasAction ? props.theme.noContrastHover : props.theme.noContrast};
  }
  span {
    color: ${(props) => props.theme.secondaryText};
  }
  @media (min-width: ${(props) => props.theme.medium}) {
    grid-template-columns: ${(props) =>
      props.columns ? props.columns : '4fr 2fr 2fr 2fr 2.5rem'};
  } ;
`;

export const EditListItem = styled.div`
  padding: 1rem;
  background: ${(props) => props.theme.noContrast};
  border-bottom: 1px solid ${(props) => props.theme.stroke};
`;

export default function List(props) {
  return (
    <ListWrapper>
      {props.listHeaderItems && (
        <ListHeader columns={props.columns} columnsMobile={props.columnsMobile}>
          {props.listHeaderItems}
        </ListHeader>
      )}
      <ListItems noBorder={props.noBorder}>
        {props.listItems || props.children}
      </ListItems>
    </ListWrapper>
  );
}
